// @ts-nocheck
import {
  NEW_CHAT_SETUP_LOADING,
  NEW_CHAT_SETUP_SUCCESS,
  NEW_CHAT_SETUP_FAILURE,
  ON_NEW_NOTE_ONE_ON_ONE_CHAT,
  MARK_NOTE_RESOLVED,
  MARK_NOTE_UNRESOLVED,
  SET_NOTE_CHAT_ROOM_MESSAGES,
  CLEAR_NOTE_CHAT_ROOM_MESSAGES,
  NOTE_CHATT_ROOM_MESSAGES_LOADING,
  CREATE_NOTES_MOUNTED,
  CREATE_NOTES_UNMOUNTED,
} from "../../store/constants/noteoneononemessaging";

const initialState = {
  notesetup: {
    isLoading: false,
    success: false,
    failure: false,
  },
  chatRoomMessages: [],
  isMounted: false,
};

const noteOneOnOneMessagingReducer = (state = initialState, action) => {
  switch (action?.type) {
    case NEW_CHAT_SETUP_LOADING: {
      return {
        ...state,
        notesetup: {
          ...state.notesetup,
          success: false,
          failure: false,
          isLoading: true,
        },
      };
    }
    case NEW_CHAT_SETUP_SUCCESS: {
      return {
        ...state,
        notesetup: {
          ...state.notesetup,
          success: true,
          failure: false,
          isLoading: false,
        },
      };
    }

    case NEW_CHAT_SETUP_FAILURE: {
      return {
        ...state,
        notesetup: {
          ...state.notesetup,
          success: false,
          failure: true,
          isLoading: false,
        },
      };
    }

    case NOTE_CHATT_ROOM_MESSAGES_LOADING: {
      return {
        ...state,
        isLoading: action?.payload || false,
      };
    }

    case SET_NOTE_CHAT_ROOM_MESSAGES: {
      const { chatRoomMessages } = action.payload;

      return {
        ...state,
        chatRoomMessages:
          chatRoomMessages?.filter((item) => item?.content) || [],
      };
    }

    case CLEAR_NOTE_CHAT_ROOM_MESSAGES: {
      return {
        ...state,
        chatRoomMessages: [],
      };
    }

    case ON_NEW_NOTE_ONE_ON_ONE_CHAT: {
      const { roomId, message } = action.payload;
      return {
        ...state,
        chatRoomMessages: [...state.chatRoomMessages, message],
      };
    }
    case MARK_NOTE_RESOLVED: {
      const { messageIds } = action.payload;

      return {
        ...state,
        chatRoomMessages: state?.chatRoomMessages?.map?.((message) => {
          if (messageIds?.find?.((currId) => currId === message?._id)) {
            return {
              ...message,
              isResolved: true,
            };
          } else {
            return message;
          }
        }),
      };
    }
    case MARK_NOTE_UNRESOLVED: {
      const { messageIds } = action.payload;
      return {
        ...state,
        chatRoomMessages: state?.chatRoomMessages?.map?.((message) => {
          if (messageIds?.find?.((currId) => currId === message?._id)) {
            return {
              ...message,
              isResolved: false,
            };
          } else {
            return message;
          }
        }),
      };
    }

    case CREATE_NOTES_MOUNTED: {
      return {
        ...state,
        isMounted: true,
      };
    }

    case CREATE_NOTES_UNMOUNTED: {
      return {
        ...state,
        isMounted: false,
      };
    }

    default:
      return state;
  }
};

export default noteOneOnOneMessagingReducer;
export { initialState };